<template>
  <div class="content-row"
    :class="{ 'content-2col': display_type !== 'box' }">
    <div id="main-col-1" class="col-1">
      <audio-list></audio-list>
    </div>
    <div id="main-col-2" class="col-2">
      <watchlist v-if="false"></watchlist>
      <navigation></navigation>
    </div>
  </div>
</template>

<script>
import AudioList from "./components/audio-list"
import Watchlist from "./components/watchlist"
import Navigation from "./components/navigation"
import { mapState } from 'vuex'

export default {
  data: function() {
    return {}
  },
  computed: {
    ...mapState(['display_type'])
  },
  created() {
    this.$store.dispatch("get_categories")
    this.$store.dispatch("get_agendas")

    // this.$moment.locale("de")

    console.log("app created")
  },

  components: {
    AudioList,
    Watchlist,
    Navigation,
  },
}
</script>
